import {modules} from "@/systems/modules/modules.js";
import AuditLogsView from "@/systems/modules/auditLogs/AuditLogsView.vue";
import authorization from "@/authorization";

export default {
    getRoutes: () => ([
        {
            name: "community.modules.auditLogs",
            path: "audit-logs",
            component: AuditLogsView,
            props: true,
            meta: {
                authorize: () => authorization.moduleEnabled(modules.auditLogs) && authorization.permission("modules.auditLogs.logs.view"),
            }
        }
    ])
};